export default "__VITE_ASSET__$J5lq20v__"